module.exports = __webpack_public_path__ + "img/icon1.1aa3cf60.png";